/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateRunClubEventDistanceDto
 */
export interface CreateRunClubEventDistanceDto {
    /**
     * Distance value
     * @type {number}
     * @memberof CreateRunClubEventDistanceDto
     */
    'distanceValue': number;
    /**
     * Distance unit
     * @type {string}
     * @memberof CreateRunClubEventDistanceDto
     */
    'distanceUnit': CreateRunClubEventDistanceDtoDistanceUnitEnum;
    /**
     * Optional label for the distance
     * @type {string}
     * @memberof CreateRunClubEventDistanceDto
     */
    'label'?: string;
}

export const CreateRunClubEventDistanceDtoDistanceUnitEnum = {
    Km: 'km',
    Mi: 'mi'
} as const;

export type CreateRunClubEventDistanceDtoDistanceUnitEnum = typeof CreateRunClubEventDistanceDtoDistanceUnitEnum[keyof typeof CreateRunClubEventDistanceDtoDistanceUnitEnum];


